// list of async actions that can take a while for BE to finish
export enum EmployeesAsyncActions {
  FromRadarToInventory = 'fromRadarToInventory',
  FromTrashToInventory = 'fromTrashToInventory',
  FromRadarToTrash = 'fromRadarToTrash',
  FromInventoryToTrash = 'fromInventoryToTrash',
  ArchiveEmployee = 'archiveEmployee',
  UnArchiveEmployee = 'unArchiveEmployee',
}